var GraphicsUtils = {

    isPointInPolygon: function(point, polygon) {
        function isLeft(p, v1, v2) {
            if (v1.x == v2.x) {
                return (p.x <= v1.x);
            } else {
                var m = (v2.y - v1.y) / (v2.x - v1.x);
                var x2 = (p.y - v1.y) / m + v1.x;
                return (p.x <= x2);
            }
        }
        //Loop through points, check if point is left of each line.
        //If it is, check if it line intersects with horizontal ray from point p
        var count = 0;
        for (var i = 0; i < polygon.length; i++) {
            var j = (i == polygon.length - 1) ? 0 : i + 1;
            var v1 = polygon[i];
            var v2 = polygon[j];
            //does point lay to the left of the line?
            if (isLeft(point, v1, v2)) {
                if ((point.y > v1.y && point.y <= v2.y) || (point.y > v2.y && point.y <= v1.y)) {
                    count++;
                }
            }
        }
        return !(count % 2 == 0);
    },

    isLocationInPolygon: function(location, polygon) {
        function isLeft(l, v1, v2) {
            if (v1.longitude == v2.longitude) {
                return (l.longitude <= v1.longitude);
            } else {
                var m = (v2.latitude - v1.latitude) / (v2.longitude - v1.longitude);
                var longitude2 = (l.latitude - v1.latitude) / m + v1.longitude;
                return (l.longitude <= longitude2);
            }
        }
        //Loop through points, check if point is left of each line.
        //If it is, check if it line intersects with horizontal ray from point p
        var count = 0;
        for (var i = 0; i < polygon.length; i++) {
            var j = (i == polygon.length - 1) ? 0 : i + 1;
            var v1 = polygon[i];
            var v2 = polygon[j];
            //does point lay to the left of the line?
            if (isLeft(location, v1, v2)) {
                if ((location.latitude > v1.latitude && location.latitude <= v2.latitude) || (location.latitude > v2.latitude && location.latitude <= v1.latitude)) {
                    count++;
                }
            }
        }
        return !(count % 2 == 0);
    }
};

export default GraphicsUtils;